import { ColumnTable, Icon, Table } from '@octano/global-ui';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { TranslationsKeys } from '../../../../locales/translations';
import { useFinantialOthersState } from '../hooks/useFinantialOthersState';
import { AcademicLevelType } from '../type';
import { FinantialOtherTitulationByStudyPlan } from './FinantialOtherTitulationByStudyPlan';

export function FinantialOtherPaymentByAcademicLevel() {
  const { t } = useTranslation(
    TranslationsKeys.CONFIGURATION_FIANANTIAL_OTHERS,
  );
  const { academicLevelsPriceState } = useFinantialOthersState();

  const [selectedLevel, setSelectedLevel] = useState<AcademicLevelType | null>(
    null,
  );

  const columns = useMemo<ColumnTable<AcademicLevelType>[]>(
    () => [
      {
        columnName: 'name',
        headerText: t('academicLevelTitulationPayment.table.level'),
        tdClassName: 'text-left',
        thClassName: 'text-left',
        cellFormat: (options) => (
          <span
            role="button"
            className="w-full d-flex h-100 align-items-center"
            style={{ cursor: 'pointer' }}
            onClick={() => setSelectedLevel(options.row)}
          >
            {options.row.name}
          </span>
        ),
      },
      {
        columnName: 'action',
        headerText: t('academicLevelTitulationPayment.table.seeMore'),
        tdClassName: 'text-right',
        thClassName: 'text-right',
        onClick: () => {
          console.log('click B');
        },
        width: '15%',
        cellFormat: (options) => (
          <span
            role="button"
            className="text-primary fs-20 fw-600 w-full d-flex h-100 align-items-center justify-content-end"
            style={{ cursor: 'pointer' }}
            onClick={() => setSelectedLevel(options.row)}
          >
            <Icon name="chevron_right" />
          </span>
        ),
      },
    ],
    [t],
  );

  if (selectedLevel) {
    return (
      <div>
        <p className="fs-16 fw-600 text-primary mt-4 mb-0">
          {t('academicLevelTitulationPayment.title')}
        </p>
        <p className="fs-14 mb-3">
          {t('academicLevelTitulationPayment.description')}
        </p>
        <FinantialOtherTitulationByStudyPlan
          academicLevelId={selectedLevel.id}
          academicLevelName={selectedLevel.name}
          onBack={() => setSelectedLevel(null)}
        />
      </div>
    );
  }

  return (
    <div>
      <p className="fs-16 fw-600 text-primary mt-4 mb-0">
        {t('academicLevelTitulationPayment.title')}
      </p>
      <p className="fs-14 mb-3">
        {t('academicLevelTitulationPayment.description')}
      </p>
      <Table columns={columns} data={academicLevelsPriceState} />
    </div>
  );
}
